import { render } from "./CitationInfoLabel.vue?vue&type=template&id=221fd248&scoped=true"
import script from "./CitationInfoLabel.vue?vue&type=script&lang=js"
export * from "./CitationInfoLabel.vue?vue&type=script&lang=js"

import "./CitationInfoLabel.vue?vue&type=style&index=0&id=221fd248&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221fd248"]])

export default __exports__